import createInboxV2Store from '@app/application/communication/screens/inbox/store/inbox-v2'
import { createApp } from '@app/adapters/create-app'
import InboxFilters from '@app/application/communication/screens/inbox/components/inbox-filters.vue'
import CompanyInboxV2 from '@app/application/communication/screens/inbox/components/company-inbox-v2.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='workflow-inbox']").each(function () {
    const data = $(this).data()
    const endpointParams = {
      companyId: Silverfin.currentCompanyId,
      ledgerId: Silverfin.currentLedgerId(),
      firmId: Silverfin.currentFirmId,
      contextType: data.contextType,
      contextId: data.contextId,
    }

    const store = createInboxV2Store(endpointParams)
    const workflowInboxApp = createApp(CompanyInboxV2)
    workflowInboxApp.use(store)
    workflowInboxApp.mount(this)

    $dom.find("[data-behaviour='inbox-filters']").each(function () {
      const filtersApp = createApp(InboxFilters)
      filtersApp.use(store)
      filtersApp.mount(this)
    })
  })
})
